import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_male_paywall_redesign~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_male_paywall_redesign/m'),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_male_paywall_redesign~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_male_paywall_redesign/chair_workouts_m'),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_male_paywall_redesign~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_male_paywall_redesign/tai_chi_yoga_m'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_male_paywall_redesign~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_male_paywall_redesign/chair_tai_chi_m'),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_male_paywall_redesign~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_male_paywall_redesign/walking_m'
					),
			},
		},
	},
]

export default config
